module.exports = __webpack_public_path__ + "img/product-shot_05.11019216.jpg";